import Fullscreen from '@mui/icons-material/Fullscreen'
import FullscreenExit from '@mui/icons-material/FullscreenExit'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { IconButton } from '@mui/material'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Carousel, Spinner } from 'react-bootstrap'
import ReactPlayer from 'react-player'
import { CADeviceUseFixingComponent } from 'src/clinic/components/ClinicHomePage/components/CADeviceUseFixingComponent'
import { StyledEventsRefreshIcon } from 'src/mentor/components/MentorEventsPage/MentorEventsPageStyles'
import { getImageLink, maskNameForClinicCounter } from 'src/mentor/helpers/utilityFunctions'
import {
  ClinicCarouselSlide,
  ClinicCarouselSlideImage,
  ClinicCarouselText,
  ClinicCarouselTextContainer,
  ClinicCounterAppointmentNumberBox,
  ClinicCounterBackground,
  ClinicCounterBody,
  ClinicCounterFooter,
  ClinicCounterHeader,
  ScreeningMentorAppointmentBox,
  StyledCarouselClinicCounter,
  TokenLabel,
  TokenPatientName,
  TokenValue,
} from '../../ClinicCounterStyles'
import {
  getPrefixRemovedAppointmentNumber,
  getScreenTitleForMentor,
  shouldShowYoutubeVideoForOOH,
} from '../../utils'
import OneMentorVideoAndOtherMentorCard from '../common/OneMentorVideoAndOtherMentorCard'

export default function OneMentorVideoAndOther({
  thisClinicData,
  mentorProfileData,
  primaryMentorCheckedIn,
  OOHData,
  bookedSlotsInDay,
  bookedSlotsInDayLoading,
  screeningMentorDataLoading,
  screeningMentors,
  handleRefreshBookedSlots,
  handleExitFullScreen,
  handleClickFullScreen,
  timeNow,
  screenfull,
  oohConfig,
}) {
  const showScreeningMentor = !!screeningMentors && screeningMentors?.length > 0
  const [currentlyShowingScreenerMentor, setCurrentlyShowingScreenerMentor] = useState(0)

  const [CAFlowDialogOpen, setCAFlowDialogOpen] = useState(false)


  //iterate through the screeningMentors and one by one just put in currentlyShowingScreenerMentor. if the item is last, return to first. delay: 45 seconds
  useEffect(() => {
    if (showScreeningMentor) {
      const interval = setInterval(() => {
        setCurrentlyShowingScreenerMentor((prevIndex) => (prevIndex + 1) % screeningMentors.length)
      }, 45000)

      // Clear interval on component unmount
      return () => clearInterval(interval)
    }
  }, [screeningMentors, showScreeningMentor])

  const [anchorElForMenu, setAnchorElForMenu] = useState(null)
  const menuOpen = Boolean(anchorElForMenu)
  const handleClickMenuOpener = (event) => {
    setAnchorElForMenu(event.currentTarget)
  }
  const handleCloseMenu = () => {
    setAnchorElForMenu(null)
  }

  return (
    <ClinicCounterBackground id="fullScreenTarget">
      <ClinicCounterHeader>
        {thisClinicData?.title}
        <div
          style={{
            position: 'absolute',
            right: '16px',
            display: 'flex',
            gap: '8px',
            flexDirection: 'row-reverse',
            alignItems: 'center',
          }}
        >
          <IconButton id="demo-positioned-button-counter" onClick={handleClickMenuOpener}>
            <MoreVertIcon style={{ color: 'rgba(255,255,255,0.9)' }} />
          </IconButton>
          {bookedSlotsInDayLoading ? (
            <Spinner animation="border" variant="light" size="sm" />
          ) : (
            <StyledEventsRefreshIcon onClick={handleRefreshBookedSlots} />
          )}
          {screenfull.isEnabled &&
            (screenfull.isFullscreen ? (
              <FullscreenExit style={{ cursor: 'pointer' }} onClick={handleExitFullScreen} />
            ) : (
              <Fullscreen style={{ cursor: 'pointer' }} onClick={handleClickFullScreen} />
            ))}
          {/* <Close style={{ cursor: 'pointer' }} onClick={() => window.history.back()} /> */}
          <MenuComponent
            anchorElForMenu={anchorElForMenu}
            menuOpen={menuOpen}
            handleCloseMenu={handleCloseMenu}
            openDeviceUseSettings={() => setCAFlowDialogOpen(true)}
          />
          <CADeviceUseFixingComponent
            CAFlowDialogOpen={CAFlowDialogOpen}
            setsCAFlowDialogOpen={setCAFlowDialogOpen}
          />
        </div>
      </ClinicCounterHeader>

      <ClinicCounterBody singleMentor={!showScreeningMentor}>
        <OneMentorVideoAndOtherMentorCard
          loading={screeningMentorDataLoading}
          mentor={mentorProfileData}
          mentorTitle={getScreenTitleForMentor(mentorProfileData)}
          checkedIn={primaryMentorCheckedIn}
          hideMentorDetails={oohConfig?.hideMentorDetails}
        >
          <div style={{ fontSize: 'clamp(12px, 1vw, 15px)', color: 'rgba(255,255,255,0.6)', lineHeight: 1.4 }}>
            {timeNow.format('ddd, MMM D')}
          </div>
          <div style={{ fontSize: 'clamp(20px, 1.8vw, 28px)', fontWeight: 700, color: 'rgba(255,255,255,0.95)', lineHeight: 1.2 }}>
            {timeNow.format('h:mm A')}
          </div>
        </OneMentorVideoAndOtherMentorCard>

        <StyledCarouselClinicCounter pause={false}>
          {OOHData?.map((carouselDataItem, carouselDataItemIndex) => {
            if (carouselDataItem?.imageType === 'image') {
              return (
                <Carousel.Item
                  interval={carouselDataItem?.durationInSec * 1000 || 5000}
                  key={carouselDataItemIndex}
                >
                  <ClinicCarouselSlide>
                    <ClinicCarouselSlideImage
                      src={getImageLink(carouselDataItem?.imageId)}
                      blackTint={
                        carouselDataItem?.title?.trim() || carouselDataItem?.subText?.trim()
                      }
                    />
                    <ClinicCarouselTextContainer>
                      <ClinicCarouselText main>{carouselDataItem?.title}</ClinicCarouselText>
                      <ClinicCarouselText>{carouselDataItem?.subText}</ClinicCarouselText>
                    </ClinicCarouselTextContainer>
                  </ClinicCarouselSlide>
                </Carousel.Item>
              )
            } else if (
              carouselDataItem?.imageType === 'youtube_video' &&
              shouldShowYoutubeVideoForOOH(thisClinicData)
            ) {
              return (
                <Carousel.Item
                  interval={carouselDataItem?.durationInSec * 1000 || 45000}
                  key={carouselDataItemIndex}
                >
                  <ClinicCarouselSlide>
                    <ReactPlayer
                      url={carouselDataItem?.youtubeUrl || carouselDataItem?.imageUrl}
                      config={{
                        playerVars: {
                          cc_lang_pref: 'hi',
                          cc_load_policy: 1,
                        },
                      }}
                      playing={true}
                      width="100%"
                      height="100%"
                      muted={true}
                    />
                  </ClinicCarouselSlide>
                </Carousel.Item>
              )
            }
            return null
          })}
        </StyledCarouselClinicCounter>

        {showScreeningMentor && (
          <ScreenerProfileCard
            screeningMentorDataLoading={screeningMentorDataLoading}
            currentlyShowingScreenerMentor={screeningMentors?.[currentlyShowingScreenerMentor]}
            bookedSlotsForScreenerInDay={
              screeningMentors?.[currentlyShowingScreenerMentor]?.bookedSlots
            }
            oohConfig={oohConfig}
          />
        )}
      </ClinicCounterBody>

      <ClinicCounterFooter>
        <ClinicCounterAppointmentNumberBox main>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <TokenLabel as="span" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {'वर्तमान टोकन' || 'Current Token'}
            </TokenLabel>
            <TokenValue as="span" className="current-token" style={{ color: '#fff' }}>
              {getPrefixRemovedAppointmentNumber(bookedSlotsInDay?.[0]?.appointmentNumber) || '--'}
            </TokenValue>
            <TokenPatientName as="span" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {'नाम' || 'Name'}: {maskNameForClinicCounter(bookedSlotsInDay?.[0]?.userName)}
            </TokenPatientName>
          </div>
        </ClinicCounterAppointmentNumberBox>
        <ClinicCounterAppointmentNumberBox>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <TokenLabel as="span" style={{ color: 'rgba(255,255,255,0.7)' }}>
              {'अगला टोकन' || 'Next token'}
            </TokenLabel>
            <TokenValue as="span" style={{ color: 'rgba(255,255,255,0.95)', fontSize: 'clamp(32px, 5.5vw, 88px)' }}>
              {getPrefixRemovedAppointmentNumber(bookedSlotsInDay?.[1]?.appointmentNumber) || '--'}
            </TokenValue>
            <TokenPatientName as="span" style={{ color: 'rgba(255,255,255,0.7)' }}>
              {'नाम' || 'Name'}: {maskNameForClinicCounter(bookedSlotsInDay?.[1]?.userName)}
            </TokenPatientName>
          </div>
        </ClinicCounterAppointmentNumberBox>
      </ClinicCounterFooter>
    </ClinicCounterBackground>
  )
}

function ScreenerProfileCard({
  screeningMentorDataLoading,
  currentlyShowingScreenerMentor,
  bookedSlotsForScreenerInDay,
  oohConfig,
}) {
  return (
    <OneMentorVideoAndOtherMentorCard
      loading={screeningMentorDataLoading}
      mentor={currentlyShowingScreenerMentor}
      mentorTitle={getScreenTitleForMentor(currentlyShowingScreenerMentor)}
      checkedIn={true}
      hideMentorDetails={oohConfig?.hideMentorDetails}
      isRightColumn
    >
      <ScreeningMentorAppointmentBox primary id="screening-mentor-curr-appointment">
        <TokenLabel as="span" style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '4px' }}>
          {'वर्तमान टोकन' || 'Current Token'}
        </TokenLabel>
        <TokenValue as="span" style={{ color: '#fff', fontSize: 'clamp(28px, 2.5vw, 42px)' }}>
          {getPrefixRemovedAppointmentNumber(
            bookedSlotsForScreenerInDay?.[0]?.appointmentNumber,
          ) || '--'}
        </TokenValue>
        <TokenPatientName as="span" style={{ color: 'rgba(255,255,255,0.9)', fontSize: 'clamp(12px, 1vw, 16px)', marginTop: '4px' }}>
          {'नाम' || 'Name'}: {maskNameForClinicCounter(bookedSlotsForScreenerInDay?.[0]?.userName)}
        </TokenPatientName>
      </ScreeningMentorAppointmentBox>
      <ScreeningMentorAppointmentBox id="screening-mentor-next-appointment">
        <TokenLabel as="span" style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '4px', textAlign: 'center' }}>
          {'अगला टोकन' || 'Next token'}
        </TokenLabel>
        <TokenValue as="span" style={{ color: 'rgba(255,255,255,0.95)', fontSize: 'clamp(24px, 2vw, 36px)' }}>
          {getPrefixRemovedAppointmentNumber(
            bookedSlotsForScreenerInDay?.[1]?.appointmentNumber,
          ) || '--'}
        </TokenValue>
        <TokenPatientName as="span" style={{ color: 'rgba(255,255,255,0.7)', fontSize: 'clamp(12px, 1vw, 16px)', marginTop: '4px' }}>
          {'नाम' || 'Name'}: {maskNameForClinicCounter(bookedSlotsForScreenerInDay?.[1]?.userName)}
        </TokenPatientName>
      </ScreeningMentorAppointmentBox>
    </OneMentorVideoAndOtherMentorCard>
  )
}

const MenuComponent = ({ anchorElForMenu, menuOpen, handleCloseMenu, openDeviceUseSettings }) => {
  const navigate = useNavigate()
  const currentPath = window.location.pathname
  const isKioskPortal = currentPath.startsWith('/kiosk')

  return (
    <Menu
      id="demo-positioned-menu"
      aria-labelledby="demo-positioned-button"
      anchorEl={anchorElForMenu}
      open={menuOpen}
      onClose={handleCloseMenu}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      {isKioskPortal ? (
        <MenuItem
          onClick={() => {
            navigate('/kiosk/select-flow')
            handleCloseMenu()
          }}
        >
          Change Flow
        </MenuItem>
      ) : (
        <MenuItem
          onClick={() => {
            openDeviceUseSettings()
            handleCloseMenu()
          }}
        >
          Change Device-use Settings
        </MenuItem>
      )}
    </Menu>
  )
}
